import { appRoutes, RouteNames } from "@/shared/constants/routes";
import { clearStorageOnLogout } from "@/shared/utils/localStorageHelpers";
import { call, put, takeLatest } from "redux-saga/effects";
import { invokeLogoutHandler } from "./sessionBridge";
import { globalActions } from "./slice";

const authOnlyPaths = Object.values(appRoutes)
  .filter((route) => route.requiresAuth)
  .map((route) => route.path.split("/:")[0]);

function* logOut() {
  try {
    yield call(invokeLogoutHandler);
  } catch (error) {
    console.error("[global] logout failed", error);
  } finally {
    yield call(clearStorageOnLogout);
    yield put(globalActions.resetState());

    // Only navigate away when the current screen needs a session. Logging out
    // while browsing the public catalogue should leave the visitor where
    // they are.
    if (typeof window !== "undefined") {
      const path = window.location.pathname;
      const isProtected = authOnlyPaths.some((prefix) =>
        path.startsWith(prefix)
      );
      if (isProtected) {
        window.location.assign(appRoutes[RouteNames.landing].path);
      }
    }
  }
}

export function* globalSaga() {
  yield takeLatest(globalActions.logOut.type, logOut);
}
